import React, { createContext, useContext } from 'react';

const PublicFlowContext = createContext<boolean>(false);

export const PublicFlowProvider: React.FC<{ children: React.ReactNode, isPublic?: boolean }> = ({ children, isPublic = true }) => {
    return (
        <PublicFlowContext.Provider value={isPublic}>
            {children}
        </PublicFlowContext.Provider>
    );
};

export const usePublicFlow = () => useContext(PublicFlowContext);

/**
 * Strips 'dark:' classes if we are inside a public flow.
 */
export const useThemeClasses = (classes: string | undefined): string => {
    const isPublic = usePublicFlow();
    if (!classes) return '';
    if (isPublic) {
        return classes.split(' ').filter(c => !c.startsWith('dark:') && !c.includes(':dark:')).join(' ');
    }
    return classes;
};
